module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "m-l-50 m-t-30"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应用名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "placeholder": "请填写应用名称"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "h-40 w-200",
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "请填写应用描述"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        _vm.form.description = $event
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应用类型",
      "label-width": "100px",
      "prop": "type"
    }
  }, [_c('el-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    domProps: {
      "value": (_vm.form.type)
    },
    on: {
      "input": function($event) {
        _vm.form.type = $event
      }
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "10"
    }
  }, [_vm._v("企业微信")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "20"
    }
  }, [_vm._v("WAP")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "30"
    }
  }, [_vm._v("APP")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主题样式",
      "label-width": "100px",
      "prop": "theme"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.theme),
      expression: "form.theme"
    }],
    attrs: {
      "placeholder": "请选择主题样式"
    },
    domProps: {
      "value": (_vm.form.theme)
    },
    on: {
      "input": function($event) {
        _vm.form.theme = $event
      }
    }
  }, _vm._l((_vm.themeList), function(theme) {
    return _c('el-option', {
      attrs: {
        "label": theme.title,
        "value": theme.theme
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应用入口",
      "label-width": "100px",
      "prop": "entrance"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.entrance),
      expression: "form.entrance"
    }],
    attrs: {
      "placeholder": "请选择应用入口"
    },
    domProps: {
      "value": (_vm.form.entrance)
    },
    on: {
      "input": function($event) {
        _vm.form.entrance = $event
      }
    }
  }, _vm._l((_vm.pages), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.btnLoading
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91b1ab86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/application/form.vue
// module id = 1956
// module chunks = 2